/**
 * Ad Configuration
 * Centralized configuration for all ad placements
 */

export const AD_CONFIG = {
  enabled: true, // Global ad toggle
  provider: 'google-adsense', // 'google-adsense' | 'custom' | 'programmatic'
  
  // Google AdSense Configuration
  googleAdSense: {
    client: 'ca-pub-3940256099942544', // Using test AdSense client for development
    enablePageLevelAds: true,
  },

  // Ad Slots Configuration
  slots: {
    // Top Banner (Leaderboard)
    topBanner: {
      enabled: true,
      slot: '1234567890', // AdSense slot ID
      format: 'horizontal',
      responsive: true,
      sizes: [[728, 90], [970, 90], [320, 50]],
      style: {
        display: 'block',
        minHeight: '90px',
        marginBottom: '20px',
      }
    },

    // Sidebar Banner (Medium Rectangle)
    sidebarBanner: {
      enabled: true,
      slot: '0987654321',
      format: 'rectangle',
      responsive: true,
      sizes: [[300, 250], [300, 600]],
      style: {
        display: 'block',
        minHeight: '250px',
        marginBottom: '20px',
      }
    },

    // Bottom Sticky Banner
    bottomSticky: {
      enabled: true,
      slot: '1122334455',
      format: 'horizontal',
      responsive: true,
      sizes: [[728, 90], [320, 50]],
      style: {
        display: 'block',
        minHeight: '50px',
      },
      sticky: true,
      stickyOffset: 0, // Distance from bottom
    },

    // In-Content Ads
    inContent: {
      enabled: true,
      slot: '5544332211',
      format: 'fluid',
      responsive: true,
      style: {
        display: 'block',
        minHeight: '250px',
        marginTop: '20px',
        marginBottom: '20px',
      }
    }
  },

  // Custom Ad Fallbacks (when AdSense not available)
  customAds: {
    topBanner: {
      imageUrl: '/ads/top-banner.jpg',
      link: 'https://example.com',
      alt: 'Advertisement',
    },
    sidebarBanner: {
      imageUrl: '/ads/sidebar-banner.jpg',
      link: 'https://example.com',
      alt: 'Advertisement',
    },
  },

  // Pages where ads should NOT be displayed
  excludedRoutes: [
    '/exam/attempt', // No ads during exam
    '/admin', // No ads in admin area
    '/reset-password', // No ads on password reset page
    '/auth/action', // No ads on Firebase action handler route
    '/__/auth/action', // No ads on Firebase reserved auth action route
  ],

  // Ad refresh settings
  refreshInterval: 30000, // Refresh ads every 30 seconds (optional)
  autoRefresh: false,
};

export const isAdAllowedOnRoute = (pathname) => {
  if (!AD_CONFIG.enabled) return false;
  return !AD_CONFIG.excludedRoutes.some(route => pathname.startsWith(route));
};
